import React, { useState } from "react";
import classnames from "classnames";
import Tooltip from "../Tooltip/Tooltip";
import {
  EyeLogo,
  EyeIcon,
  iIcon,
  doller,
  searchAll,
  searchFilterIcon,
  crossIcon,
  sendMsgIcon
} from "../../assets/images";
import "./textInput.css";
import "./textInput.scss";

const TextInput = ({
  label,
  placeholder,
  name,
  tabIndex,
  onFocus,
  value,
  className,
  containerClass,
  onChange,
  onBlur,
  required,
  disabled,
  style,
  innerRef,
  type,
  id,
  signuperrornone,
  error,
  labelFent,
  data,
  phone,
  testimonialTooltip,
  testimonialTooltipPhone,
  accept,
  containerStyle,
  dollerInput,
  onclickserach,
  onKeyPress,
  filterField,
  onKeyUp,
  showCross,
  onCrossClick,
  onSearchClick,
  autoComplete,
  maxLength,
  onInputIconClick
}) => {
  const [showPassword, setShowPassword] = useState(false);
    
  const onfieldBlur = (e)=> {
    e.target.value = e.target.value?.trim()
    if(onBlur) {
      onBlur()
    }
  }
  return (
    <div className={classnames(containerClass, "inputNewWrapper")} style={containerStyle}>
      {label && <p className="formLabel mb-0">{label}</p>}
      {labelFent && <p className="formLabelDropdown mb-0">{labelFent}</p>}
      <div
        className="d-flex align-items-center"
        style={{ position: "relative" }}
      >
        {dollerInput && (
          <img
            src={doller}
            className="dollrActive"
            onClick={() => setShowPassword((prevState) => !prevState)}
            alt=""
          />
        )}
        <textarea
          type={filterField ? "search" : type === "password" ? (showPassword ? "text" : type) : type}
          required={required}
          value={value}
          name={name}
          ref={innerRef}
          className={classnames(
            error
              ? "inputBox form-control inputBoxError"
              : "inputBox form-control inputBoxNormal",
            className
          )}
          style={{
            ...style,
            width: "100%",
          }}
          onFocus={onFocus}
          onKeyPress={onKeyPress}
          disabled={disabled}
          onChange={onChange}
          onBlur={onfieldBlur}
          placeholder={placeholder}
          id={id}
          maxLength={maxLength}
          onKeyUp={onKeyUp}
          accept={accept}
          tabIndex={tabIndex}
          autoComplete={autoComplete ? "on" : "off"}
        />
        {type === "password" && (
          <img
            src={showPassword ? EyeLogo : EyeIcon}
            className={showPassword ? "eyeLogoActive " : "eyeLogo "}
            onClick={() => setShowPassword((prevState) => !prevState)}
            alt=""
          />
        )}
        {(type === "searchIcon" && !filterField) && (
          <img
            src={searchAll}
            className="searchLogo"
            onClick={onclickserach || onSearchClick}
            alt=""
          />

        )}
        {filterField && (
          <img
            src={searchFilterIcon}
            className="searchFilterLogo"
            onClick={onSearchClick}
            alt=""
          />
        )}
        {type === "sendMessage" && (
          <img
            src={sendMsgIcon}
            className="searchLogo1"
            onClick={onInputIconClick}
            alt=""
          />
        )}
        {showCross && (
          <img
            src={crossIcon}
            className="closeLogo"
            onClick={onCrossClick}
            alt=""
          />
        )}
        {testimonialTooltip === true && (
          <div className="ms-2 bigscreentooltip">
            <Tooltip
              content="This is the name of the project you worked on for the client"
              direction="right"
            >
              <img src={iIcon} alt="" />
            </Tooltip>
          </div>
        )}
        {testimonialTooltipPhone === true && (
          <div className="ms-2 mobileView">
            <Tooltip
              content="This is the name of the project you worked on for the client"
              direction="bottom"
            >
              <img src={iIcon} alt="" />
            </Tooltip>
          </div>
        )}
        {phone === true && (
          <div className="ms-2 phoneInfo">
            <Tooltip content={data} direction="bottom">
              <img src={iIcon} alt="" />
            </Tooltip>
          </div>
        )}
        {
          filterField && (
            <img
              src={crossIcon}
              className="crossOutsideIcon"
              onClick={onCrossClick}
              alt=""
            />
          )
        }
      </div>
      {error && (
        <div className="">
          <span
            className={
              signuperrornone === true
                ? "d-none"
                : "d-flex align-items-center my-2"
            }
          >
            <i className="fa fa-exclamation-circle errorIcon" />

            <p className="errorText mb-0 ">{error}</p>
          </span>
        </div>
      )}
    </div>
  );
};

export default TextInput;